import Reveal from "@/components/Reveal";

export const Recognition190 = ({ data }) => {
  const quotes = data?.quotes || [];
  return (
    <section id="recognition" className="dark-section py-28 md:py-44" data-testid="the190-recognition" style={{ scrollMarginTop: 80 }}>
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <Reveal slow>
          <p className="hairline opacity-60 mb-6">Independent Recognition</p>
          <h2 className="font-wordmark text-5xl md:text-7xl leading-[1.02] max-w-4xl">
            Recognised across art, heritage &amp; culture
          </h2>
          <p className="font-serif italic text-xl md:text-2xl opacity-75 mt-8 max-w-3xl">
            Independent professionals recognise the artistic, heritage and research
            significance of the Nick Fraser Archive.
          </p>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14 mt-16 md:mt-24">
          {quotes.map((q, i) => (
            <Reveal key={q.id || i} delay={i * 90} data-testid={`the190-quote-${q.id || i}`}>
              <div className="border-t border-white/15 pt-7 h-full">
                {q.body ? (
                  <p className="font-serif italic text-xl md:text-2xl leading-[1.4]">
                    &ldquo;{q.body}&rdquo;
                  </p>
                ) : (
                  <p className="font-serif italic text-lg md:text-xl leading-[1.4] opacity-40">
                    Approved excerpt to follow.
                  </p>
                )}
                <p className="hairline opacity-70 mt-7">{q.name}</p>
                {q.role ? <p className="hairline opacity-40 mt-1.5">{q.role}</p> : null}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export const Timeline190 = () => null;

export default Recognition190;
